/**
 * Testo mostrato nelle celle calendario assenze (stesso criterio in vista e in PDF).
 */
import {
  getEffectiveAbsences,
  getDesiderataForDoctorDate,
  isDoctorAbsent,
  getSlotBlocksForDoctorDate,
} from './store.js';
import {
  ABSENCE_CATEGORIES,
  ABSENCE_CATEGORY_ABBR,
  DESIDERATA_TYPES,
  DESIDERATA_TO_SLOT_LETTERS,
} from './types.js';

const slotCategories = [ABSENCE_CATEGORIES.LIBERA_PROFESSIONE, ABSENCE_CATEGORIES.FORMAZIONE];

function isLegacyLpDesiderataToken(raw) {
  const token = String(raw || '').trim().toLowerCase();
  if (!token) return false;
  const compact = token.replace(/[^a-z0-9]+/g, '');
  return compact === 'lp' || compact.startsWith('lp') || compact.includes('liberaprofessione');
}

export function getDesiderataAbbr(desiderataTypes) {
  if (!desiderataTypes?.length) return '';
  const letters = new Set();
  let noRg = false;
  let noRn = false;
  let hasLp = false;
  for (const t of desiderataTypes) {
    if (t === DESIDERATA_TYPES.NO_REPERIBILITA_GIORNO) {
      noRg = true;
      continue;
    }
    if (t === DESIDERATA_TYPES.NO_REPERIBILITA_NOTTE) {
      noRn = true;
      continue;
    }
    if (isLegacyLpDesiderataToken(t)) {
      hasLp = true;
      continue;
    }
    for (const L of DESIDERATA_TO_SLOT_LETTERS[t] || []) letters.add(L);
  }
  const ordered = ['M', 'P', 'N'].filter(L => letters.has(L));
  const parts = [];
  if (ordered.length) parts.push('NO ' + ordered.join(''));
  if (noRg) parts.push('NO RG');
  if (noRn) parts.push('NO RN');
  if (hasLp) parts.push('LP');
  return parts.join(' ');
}

export function getAbsenceAbbrForDoctorDate(doctorId, dateStr, rangeStart, rangeEnd) {
  if (!rangeStart || !rangeEnd) return '';
  const absences = getEffectiveAbsences(rangeStart, rangeEnd).filter(a => {
    if (a.doctorId !== doctorId) return false;
    const start = (a.dateStart || '').slice(0, 10);
    const end = (a.dateEnd || a.dateStart || '').slice(0, 10) || start;
    if (!start) return false;
    return dateStr >= start && dateStr <= end;
  });
  if (absences.length === 0) return '';
  const rangeAbs = absences.filter(a => !slotCategories.includes(a.category));
  const slotAbs = absences.filter(a => slotCategories.includes(a.category));
  const letters = new Set();
  rangeAbs.forEach(a => {
    const ab = ABSENCE_CATEGORY_ABBR[a.category];
    if (ab) letters.add(ab);
  });
  slotAbs.forEach(a => {
    const ab = ABSENCE_CATEGORY_ABBR[a.category];
    if (ab) letters.add(ab);
  });
  return [...letters].join(' ');
}

export function getAbsenceCalendarCellLabel(doctorId, dateStr, rangeStart, rangeEnd) {
  const absent = isDoctorAbsent(doctorId, dateStr);
  const slotBlocks = getSlotBlocksForDoctorDate(doctorId, dateStr);
  const hasLibera = slotBlocks.liberaProfessione.length > 0;
  const hasFormazione = slotBlocks.formazione.length > 0;
  const desiderata = getDesiderataForDoctorDate(doctorId, dateStr);
  const abbr = getAbsenceAbbrForDoctorDate(doctorId, dateStr, rangeStart, rangeEnd);
  const desiderataAbbr = getDesiderataAbbr(desiderata);
  if (absent || hasLibera || hasFormazione) return abbr;
  return desiderataAbbr;
}
